/// <amd-module name="Repos/Artifact/Discussion/RestClient/DiscussionInternal" />
import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Discussion from "../Contracts/Discussion";

export interface IDiscussionRestClient extends IVssRestClient {
    /**
     * Read a discussion thread by id GET /_apis/discussion/threads/\{discussionId\}
     *
     * @param discussionId -
     */
    getThreads(artifactUri: string): Promise<Discussion.DiscussionThread[]>;
}

class DiscussionRestClient extends RestClientBase implements IDiscussionRestClient {
    /**
     * Read a discussion thread by id GET /_apis/discussion/threads/\{discussionId\}
     *
     * @param discussionId -
     */
    public async getThreads(artifactUri: string): Promise<Discussion.DiscussionThread[]> {
        const queryValues: any = { artifactUri };
        return this.beginRequest<Discussion.DiscussionThread[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/discussion/Threads",
            queryParams: queryValues
        });
    }
}

export const DiscussionClientName = "Repos.CommitDetail.DiscussionInternal.IDiscussionRestClient";

export function getDiscussionClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IDiscussionRestClient {
    return pageContext.getRestClient<IDiscussionRestClient>(DiscussionClientName, options);
}

RestClients.add(DiscussionClientName, {
    factory: DiscussionRestClient,
    options: {
        resourceAreaId: "6823169a-2419-4015-b2fd-6fd6f026ca00",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
